/**
 * main.tsx
 * =============================================================================
 * Application entry point for Neuro-Audio Lab.
 * 
 * @author Neuro-Audio Lab
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/globals.css';

// Mount application
const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found. Make sure there is a <div id="root"></div> in your HTML.');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);